import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-translate';
import Dropzone from 'react-dropzone'

import {
    Modal,
    Grid,
    Button,
    Header,
    Item,
    Input,
    Checkbox,
    Image as Img,
    Form,
    Container,
    Divider,
    Icon,
    Label,
    Segment,
} from 'semantic-ui-react';

import createList from '../../../assets/icons/createList.png';
import plusWhite from '../../../assets/img/plus_white_18x18.png';
import Exit from '../../../assets/svg/Exit.svg';
import upload from '../../../assets/img/upload.png';
import { addArticle } from '../../../redux/actions/ListAction'

import API from '../../../services/api';

import './AddListArticle.css';

const mapStateToProps = state => ({
    app: state.app,
    list: state.list
})

const mapActionToProps = {
    addArticle: addArticle
}

class ConnectedAddListArticle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fkuidlist: this.props.fkuidlist,
            fkuidarticle: null,
            quantity: '',
            price: '',
            state: '1',
            title: '',
            response: null,
            responsa: null,
            responso: null,
            error: null,
            name_article: null,
            q: null,
            importImg: null,
            modalOpen: false,
            preview: null,
            errorImageSize: false,
            errorImageType: false
        }

        this.handleSubmitListArticleCreateArticle = this.handleSubmitListArticleCreateArticle.bind(this);

        this.handleChangePrice = this.handleChangePrice.bind(this);
        this.handleChangeImportImg = this.handleChangeImportImg.bind(this);
        this.handleChangeQuantity = this.handleChangeQuantity.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.handleChangeTitle = this.handleChangeTitle.bind(this);
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.handleDropRejected = this.handleDropRejected.bind(this);
        this.handleOpenClick = this.handleOpenClick.bind(this);
        this.resizeImage = this.resizeImage.bind(this);
    }

    resizeImage(settings) {
        var file = settings.file;
        var maxSize = settings.maxSize;
        var reader = new FileReader();
        var image = new Image();
        var canvas = document.createElement('canvas');
        var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
                atob(dataURI.split(',')[1]) :
                unescape(dataURI.split(',')[1]);
            var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++)
                ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
        };
        var blobToFile= function(theBlob, fileName){
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.fileName = fileName;
            return theBlob;
        }
        var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
                if (width > maxSize) {
                    height *= maxSize / width;
                    width = maxSize;
                }
            } else {
                if (height > maxSize) {
                    width *= maxSize / height;
                    height = maxSize;
                }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL('image/png');
            return blobToFile(dataURItoBlob(dataUrl), file.name);
        };
        return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
                no(new Error("Not an image"));
                return;
            }
            reader.onload = function (readerEvent) {
                image.onload = function () { return ok(resize()); };
                image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
        });
    };


    handleSubmitListArticleCreateArticle(event) {

        event.preventDefault();
        var form = new FormData();
        form.append("title", this.state.title);
        form.append("price", this.state.price);
        form.append("quantity", this.state.quantity);
        form.append("state", this.state.state);
        form.append("fkuidlist", this.state.fkuidlist);

        if (this.state.title !== undefined && this.state.title !== null && this.state.title !== "") {
            form.append("title", this.state.title);
        } else {
            form.append("title", "Nouvel Article");
        }
        if (this.state.price !== undefined && this.state.price !== null && this.state.price !== "") {
            form.append("price", this.state.price);
        }
        else {
            form.append("price", 0);
        }
        if (this.state.quantity !== undefined && this.state.quantity !== null && this.state.quantity !== "") {
            form.append("quantity", this.state.quantity);
        } else {
            form.append("quantity", 1);
        }
        if (this.state.state !== undefined && this.state.state !== null && this.state.state !== "") {
            form.append("state", this.state.state);
        } else {
            form.append("state", 1);
        }
        if (this.state.importImg !== undefined && this.state.importImg !== null) {
            if(!this.state.importImg.name){
                var convertedFile = new File([this.state.importImg], this.state.importImg.fileName, {type: this.state.importImg.type, lastModified: this.state.importImg.lastModifiedDate});
                form.append("importImg", convertedFile )
            } else {
                form.append("importImg", this.state.importImg);
            }
        }
        form.append("fkuidlist", this.state.fkuidlist);
        var self = this;
        API.createManualUserArticle(this.props.app.token, form).then((res) => {
            var response = res.data;
            self.setState({
                response: response
            })
            self.addArticle();
            self.setState({
                title: null,
                price: '',
                quantity: null,
                state: '1',
                importImg: null,
                errorImageSize: false,
                errorImageType: false,
                preview: null,
            });
        }, (rej) => {
            this.setState({
                error: rej.error
            })
        });


    }

    handleChangeCheckbox(e, value) {
        this.setState({ state: value })
    }

    addArticle() {
        var self = this;
        var articleListData = {
            fkuidlist : this.state.fkuidlist
        }
        API.getArticleList(this.props.app.token, articleListData).then((res) => {
            var response = res.data;
            self.props.addArticle(response.articles);
            self.handleClose();
        });
    }

    handleChangePrice(event) {
        let value = event.target.value.replace(/[^\d+\.,]+/, '');
        value = value.replace(/,/, '.');
        if ((value.match(/./g) || []).length > 1) {
            let arr = value.split(".");
            value = arr.splice(0, 2).join('.') + arr.join('');
        }

        this.setState({
            price: value,
        });
    }

    handleChangeQuantity(event) {
        let value = event.target.value.replace(/\D+/, '');
        this.setState({
            quantity: value
        });
    }

    handleChangeTitle(event) {
        this.setState({
            title: event.target.value
        });
    }

    handleChangeState(event) {
        this.setState({
            state: event.target.value
        });
    }

    handleChangeImportImg(event) {
        event.preventDefault();
        if ((event.target.files.length > 0 ? event.target.files[0].size : 0) <= 300000) {
            this.setState({
                importImg: event.target.files.length > 0 ? event.target.files[0] : null,
                errorImageSize: false
            });
        } else {
            this.setState({
                importImg: null,
                errorImageSize: true
            });
        }
    }

    handleOpenClick() {
        this.dropzone.open();
    }

    handleOpen = () => this.setState({
        modalOpen: true,
    })

    handleClose = () => this.setState({
        modalOpen: false,

    })

    handleDrop(acceptedFiles) {
        var that = this;
        // Check image size
        if (acceptedFiles.length > 0) {
            if (acceptedFiles[0].size > 300000) {
                // this.setState({
                //     preview: null,
                //     importImg: null,
                //     errorImageSize: true,
                //     errorImageType: false
                // })
                this.resizeImage({
                    file: acceptedFiles[0],
                    maxSize: 450
                }).then(function (resizedImage) {
                    that.setState({
                        preview: acceptedFiles[0].preview,
                        importImg: resizedImage,
                        errorImageSize: false,
                        errorImageType: false
                    })
                }).catch(function (err) {
                });
            } else {
                this.setState({
                    preview: acceptedFiles[0].preview,
                    importImg: acceptedFiles[0],
                    errorImageSize: false,
                    errorImageType: false
                })
            }
        }
    }

    handleDropRejected(...args) {
        this.setState({
            errorImageType: true,
            errorImageSize: false
        })
    }

    render() {
        const { t } = this.props
        let condition = (this.state.error !== null);
        let conditionResponse = (this.state.response !== null);

        var errorMessageLogin = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '1.2em'
        }
        let errorInputImage = this.state.errorImageType ? t('error_type_img')
            : (this.state.errorImageSize ? t('error_size_img') : '')

        return (
            <Modal size='tiny' open={this.state.modalOpen}
                onClose={this.handleClose} trigger={
                    <Grid.Column width={4} textAlign='center' verticalAlign='middle' style={{ textAlign: 'center' }}>
                        <Button
                            circular
                            onClick={this.handleOpen}
                            size='small'
                            floated='right'
                            src={createList}
                            id="smallBtn">
                            <Icon name='plus circle' /> {t('title1')}
                        </Button>
                    </Grid.Column>
                }>
                <Modal.Header id="modalHeader">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column textAlign='center'>
                                <Img
                                    id="modalExit"
                                    onClick={this.handleClose}
                                    src={Exit}
                                    floated='right' />
                                <Header
                                    as='h2'
                                    id="modalTitle"
                                    textAlign='center'>
                                    {t("title2")}
                                </Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content >
                    <Grid
                        verticalAlign='middle'
                        padded >
                        <Grid.Row>
                            <Item.Header id="headerAddListArticle" fluid style={{ marginBottom: '10px' }}>{t("title3")}</Item.Header>
                            <Container id="dropdownContainerAddListArticle" textAlign='center'>
                                <Dropzone
                                    ref={(node) => { this.dropzone = node; }}
                                    onDrop={this.handleDrop}
                                    accept="image/jpeg,image/jpg,image/tiff,image/gif, image/png"
                                    multiple={false}

                                    onDropRejected={this.handleDropRejected}
                                    className='dropzoneAddListArticle'>
                                    {
                                        this.state.preview ? (
                                            <Img src={this.state.preview} className='dropzonePreviewImageAddListArticle' />
                                        ) : (
                                                <Img src={upload} className='dropzoneDefaultPreviewImage' />
                                            )
                                    }
                                    <Item.Header id="itemHeaderAddListArticle" fluid>{t("title4")}</Item.Header>
                                </Dropzone>
                                <Divider id="dividerAddListArticle" horizontal><i>{t("title5")}</i></Divider>
                                <Button id='labelButton' type="button" onClick={this.handleOpenClick}>
                                    {t("title6")}
                                </Button>
                            </Container>


                        </Grid.Row>
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign='left' width={6}>
                                <Item.Header id="itemHeaderAddListArticle" fluid>{t("title7")}</Item.Header>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <Form>
                                    <input id="inputAddListArticle" type='text' name='title' value={this.state.title} onChange={this.handleChangeTitle} />
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign='left' width={6}>
                                <Item.Header id="itemHeaderAddListArticle" >{t("title8")}</Item.Header>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <Form>
                                    <input id="inputAddListArticle" fluid name='price' value={this.state.price} onChange={this.handleChangePrice} />
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign='left' width={6}>
                                <Item.Header id="itemHeaderAddListArticle" >{t("title9")}</Item.Header>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <Form>
                                    <input
                                        id="inputAddListArticle"
                                        fluid
                                        value={this.state.quantity}
                                        name='quantity'
                                        onChange={this.handleChangeQuantity}
                                    />
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign='left' width={6}>
                                <Item.Header id="itemHeaderAddListArticle" >{t("title10")}</Item.Header>
                            </Grid.Column>
                            <Grid.Column width={9} id="createArticleCheckbox">

                                <Grid>
                                    <Grid.Row columns={2}>

                                        <Grid.Column textAlign='left' width={8}>

                                            <label
                                                style={{ cursor: 'pointer', paddingLeft: '30px', fontSize: '1.2em', color: 'rgb(114, 114, 114)', marginBottom: '0', display: 'inline-block' }}
                                                className="custom-checkbox-container">
                                                <input
                                                    type="checkbox" value='1'
                                                    checked={this.state.state === '1'}
                                                    id="checkbox"
                                                    onChange={e => this.handleChangeCheckbox(e, '1')} />
                                                <span className="custom-checkbox-checkmark"></span>
                                                {t("label1")}
                                            </label>

                                        </Grid.Column>

                                        <Grid.Column textAlign='left' width={8}>

                                            <label
                                                style={{ cursor: 'pointer', paddingLeft: '30px', fontSize: '1.2em', color: 'rgb(114, 114, 114)', marginBottom: '0', display: 'inline-block' }}
                                                className="custom-checkbox-container">
                                                <input
                                                    type="checkbox"
                                                    value='0'
                                                    checked={this.state.state === '0'}
                                                    id="checkbox"
                                                    onChange={e => this.handleChangeCheckbox(e, '0')} />

                                                <span className="custom-checkbox-checkmark"></span>
                                                {t("label2")}
                                            </label>

                                        </Grid.Column>
                                    </Grid.Row>

                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                        {
                            this.state.errorImageSize || this.state.errorImageType ? (

                                <Segment inverted color='red' tertiary style={errorMessageLogin} style={{ margin: '10px auto' }}>
                                    <Icon name={"remove circle"} />{errorInputImage}
                                </Segment>


                            ) : (
                                    <div></div>
                                )
                        }
                        <Grid.Row columns={2}>
                            <Grid.Column width={8}>
                                <Button
                                    id="cancelBtn"
                                    size='massive'
                                    fluid
                                    onClick={this.handleClose} >
                                    {t("button1")}
                                </Button>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <form onSubmit={this.handleSubmitListArticleCreateArticle} >
                                    <Button
                                        id="validBtn"
                                        size='massive'
                                        fluid>
                                        {t("button2")}
                                    </Button>
                                </form>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
            </Modal>
        );
    }
}

const AddListArticle = connect(mapStateToProps, mapActionToProps)(ConnectedAddListArticle);
export default translate("AddListArticle")(AddListArticle);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/AddListArticle.js